import React, { Suspense, useEffect, useState } from "react";
import PropTypes from "prop-types";

/* fix android polyfill https://stackoverflow.com/questions/41736735/react-native-and-intl-polyfill-required-on-android-device */
import 'intl';

import get from "lodash/get";
import mapValues from "lodash/mapValues";
import { addLocaleData, IntlProvider } from "react-intl";
import en from "react-intl/locale-data/en";
import pt from "react-intl/locale-data/pt";
import es from "react-intl/locale-data/es";
import localeEn from "@meta-awesome/i18n/locales/en";
import localePtBR from "@meta-awesome/i18n/locales/pt-BR";
import { I18nContextProvider } from "./I18nContext";

const I18nProvider = props => {
  const {
    language,
    children,
    dictionaries: additionalDictionaries,
    additionalsLocaleData,
    fallbackComponent,
    textComponent: DefaultTextComponent,
    ...otherReactIntlProps
  } = props;

  const [mounted, setMounted] = useState(false);
  const [messages, setMessages] = useState({});
  const [locales] = useState({
    en: localeEn,
    "pt-BR": localePtBR
  });

  useEffect(() => {
    addLocaleData([...en, ...pt, ...es, ...additionalsLocaleData]);
    if (!mounted) {
      setMounted(true);
    }
  }, [additionalsLocaleData]);

  useEffect(() => {
    const dictionaries = {
      ...additionalDictionaries,
      ...mapValues(locales, (translations, locale) => ({
        ...translations,
        ...get(additionalDictionaries, locale, {})
      }))
    };

    setMessages(get(dictionaries, language, {}));
  }, [language, additionalDictionaries]);

  return (
    mounted && (
      <Suspense fallback={fallbackComponent}>
        <IntlProvider
          locale={language}
          messages={messages}
          key={language}
          {...otherReactIntlProps}
        >
          <I18nContextProvider DefaultTextComponent={DefaultTextComponent}>
            {children}
          </I18nContextProvider>
        </IntlProvider>
      </Suspense>
    )
  );
};

I18nProvider.propTypes = {
  language: PropTypes.string,
  children: PropTypes.element,
  dictionaries: PropTypes.shape({
    en: PropTypes.object,
    "pt-BR": PropTypes.object
  }),
  additionalsLocaleData: PropTypes.array,
  fallbackComponent: PropTypes.element,
  textComponent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ])
};

I18nProvider.defaultProps = {
  language: "pt-BR",
  children: null,
  dictionaries: {},
  additionalsLocaleData: [],
  fallbackComponent: <div />,
  textComponent: 'span'
};

export default I18nProvider;
